import { HeadingText } from '@/components/atoms/HeadingText';
import { Textarea } from '@/components/atoms/Textarea';
import { useFormContext } from '@/components/forms/FormContext';
import { type RepairFormState, StepMap, steps } from '../../constants';
import { isValid } from './state';
import { Step } from '@/components/forms/Step';
import { handleNext } from './routing';
import { useValidateStep } from '@/components/forms/useValidateStep';
import { RepairFormActionMap } from '../../reducer';
import { TextAlert } from '@/components/calculators/TextAlert';
import { IconInfoBubble } from '@/components/icons';

export interface MessageStepProps {
	testId?: string;
}

const MessageStep = (props: MessageStepProps) => {
	const { testId = 'MessageStep' } = props;
	const { state, dispatch } = useFormContext<
		StepMap,
		RepairFormState,
		RepairFormActionMap
	>();
	useValidateStep<StepMap, RepairFormState, RepairFormActionMap>(
		isValid,
		steps.Message,
	);

	function handleChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
		dispatch({ type: 'UPDATE_MESSAGE', payload: event.target.value });
	}

	return (
		<div data-testid={testId}>
			<Step<StepMap, RepairFormState, RepairFormActionMap>
				name={steps.Message}
				onNext={handleNext}
			>
				<HeadingText
					tag="h1"
					size="h2"
					className="mb-3 mt-10 lg:mb-4 lg:mt-20"
					balanced
				>
					Anything else you’d like to add?
				</HeadingText>

				<p className="mb-10 text-center text-xl tracking-tighter text-black lg:mb-14 lg:text-2xl">
					Optional
				</p>

				<div className="mb-8 grid gap-6 lg:mb-10 lg:grid-cols-3 lg:gap-8">
					<div className="lg:col-start-2">
						<Textarea
							id="message"
							name="message"
							label="Comments"
							inputClassName="!h-full"
							fieldsetClassName="h-full"
							onChange={handleChange}
							value={state.message}
						/>
					</div>
				</div>
				<TextAlert
					id="WhatAsking"
					renderIcon={IconInfoBubble}
					title="What are we looking for here?"
					text="Add anything you think would help us understand your HVAC needs. If nothing comes to mind, feel free to skip to the next step!"
				/>
			</Step>
		</div>
	);
};

export default MessageStep;
